"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fractions = exports.Imperfections = exports.Uses = exports.Design = exports.Content = exports.Shape = exports.Qualities = exports.Weave = exports.TrimType = exports.KnownOrEstimated = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["By Meter"] = "By Meter";
    SellingUnit["Bundle"] = "Bundle";
    SellingUnit["Roll"] = "Roll";
    SellingUnit["Pack"] = "Pack";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var KnownOrEstimated;
(function (KnownOrEstimated) {
    KnownOrEstimated["Known"] = "Known";
    KnownOrEstimated["Estimated"] = "Estimated";
})(KnownOrEstimated = exports.KnownOrEstimated || (exports.KnownOrEstimated = {}));
var TrimType;
(function (TrimType) {
    TrimType["Ribbon"] = "Ribbon";
    TrimType["Lace"] = "Lace";
    TrimType["Tape"] = "Tape";
    TrimType["Cording"] = "Cording";
    TrimType["Webbing"] = "Webbing";
    TrimType["Piping"] = "Piping";
    TrimType["Faux Fur"] = "Faux Fur";
    TrimType["Braided"] = "Braided";
    TrimType["Ricrac"] = "Ricrac";
})(TrimType = exports.TrimType || (exports.TrimType = {}));
var Weave;
(function (Weave) {
    Weave["Satin"] = "Satin";
    Weave["Crochet"] = "Crochet";
    Weave["Bobbin"] = "Bobbin";
    Weave["Mesh"] = "Mesh";
    Weave["Twill"] = "Twill";
    Weave["Braided"] = "Braided";
    Weave["Looped"] = "Looped";
    Weave["Rope"] = "Rope";
    Weave["Fabric Covered"] = "Fabric Covered";
})(Weave = exports.Weave || (exports.Weave = {}));
var Qualities;
(function (Qualities) {
    Qualities["Metallic"] = "Metallic";
    Qualities["Velvet"] = "Velvet";
    Qualities["Latex Grip"] = "Latex Grip";
    Qualities["Vintage"] = "Vintage";
    Qualities["Glitter"] = "Glitter";
    Qualities["Sequins"] = "Sequins";
    Qualities["Rhinestones"] = "Rhinestones";
    Qualities["Beaded"] = "Beaded";
    Qualities["Cording"] = "Cording";
    Qualities["Embroidered"] = "Embroidered";
    Qualities["Hand Made"] = "Hand Made";
    Qualities["Long Hair"] = "Long Hair";
    Qualities["Medium Hair"] = "Medium Hair";
    Qualities["Short Hair"] = "Short Hair";
    Qualities["Grommet"] = "Grommet";
    Qualities["Snap"] = "Snap";
    Qualities["Hook and Eye"] = "Hook and Eye";
    Qualities["Stretchy"] = "Stretchy";
})(Qualities = exports.Qualities || (exports.Qualities = {}));
var Shape;
(function (Shape) {
    Shape["Ruffles"] = "Ruffles";
    Shape["Scallops"] = "Scallops";
    Shape["Fringe"] = "Fringe";
    Shape["Pom Poms"] = "Pom Poms";
    Shape["Tassels"] = "Tassels";
})(Shape = exports.Shape || (exports.Shape = {}));
var Content;
(function (Content) {
    Content["Cotton"] = "Cotton";
    Content["Polyester"] = "Polyester";
    Content["Nylon"] = "Nylon";
    Content["Poly/Spandex Blend"] = "Poly/Spandex Blend";
    Content["Rayon"] = "Rayon";
    Content["Acrylic"] = "Acrylic";
    Content["Silk"] = "Silk";
    Content["Leather"] = "Leather";
    Content["Unknown"] = "Unknown";
})(Content = exports.Content || (exports.Content = {}));
var Design;
(function (Design) {
    Design["Floral"] = "Floral";
    Design["Polka Dots"] = "Polka Dots";
    Design["Stripes"] = "Stripes";
    Design["Paisley"] = "Paisley";
    Design["Abstract"] = "Abstract";
})(Design = exports.Design || (exports.Design = {}));
var Uses;
(function (Uses) {
    Uses["Home Decor"] = "Home Decor";
    Uses["Accessories"] = "Accessories";
    Uses["Apparel"] = "Apparel";
    Uses["Belting"] = "Belting";
    Uses["Strapping"] = "Strapping";
})(Uses = exports.Uses || (exports.Uses = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Marks"] = "Marks";
    Imperfections["Dusty"] = "Dusty";
    Imperfections["Discoloured"] = "Discoloured";
    Imperfections["Vintage Scent"] = "Vintage Scent";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
var Fractions;
(function (Fractions) {
    Fractions["1/2"] = "\u00BD";
    Fractions["1/3"] = "\u2153";
    Fractions["1/4"] = "\u00BC";
    Fractions["1/5"] = "\u2155";
    Fractions["1/6"] = "\u2159";
    Fractions["1/7"] = "\u2150";
    Fractions["1/8"] = "\u215B";
    Fractions["1/9"] = "\u2151";
    Fractions["1/10"] = "\u2152";
    Fractions["2/3"] = "\u2154";
    Fractions["2/5"] = "\u2156";
    Fractions["3/4"] = "\u00BE";
    Fractions["3/5"] = "\u2157";
    Fractions["3/8"] = "\u215C";
    Fractions["4/5"] = "\u2158";
    Fractions["5/6"] = "\u215A";
    Fractions["5/8"] = "\u215D";
    Fractions["7/8"] = "\u215E";
})(Fractions = exports.Fractions || (exports.Fractions = {}));
//# sourceMappingURL=trimAttributes.js.map